import './types/imports';
import Vue from 'vue';
import App from './App.vue';
//import './registerServiceWorker';
import router from './router.index';
import store from './store.index';
import vuetify from './pluggins/vuetify';
import { EventBus } from './pluggins/event-bus';
import moment from 'moment';
moment.locale( 'es' );

import { settings } from './ext';
import { UsuarioActual } from './shared/login/autenticar';
//settings.URL.api = 'http://186.139.114.238:4006';
//settings.URL.static = 'http://186.139.114.238:4006/static/';
//settings.URL.data= 'http://186.139.114.238:4006/data/';

import socketio from 'socket.io-client';
import VueSocketIOExt from 'vue-socket.io-extended';
const Socket = socketio( settings.URL.api, {
    autoConnect: false,

} );

Vue.use( VueSocketIOExt, Socket );


Vue.config.productionTip = false;
Vue.prototype.$EventBus = Vue.observable( new EventBus() );
Vue.prototype.$Usuario = Vue.observable( UsuarioActual );

new Vue( {
    router,
    store,
    vuetify,
    render: h => h( App )
} ).$mount( '#app' );

export { Socket };